import { createReducer, on } from '@ngrx/store';

// Actions
import { toggleLoaderState } from './loader.actions';

export const loaderFeatureKey = 'loader';

export interface ILoaderState {
  state: boolean;
}

export const initialState: ILoaderState = {
  state: false,
};

export const loaderReducer = createReducer(
  initialState,
  on(toggleLoaderState, (currentState, { state }) => ({
    ...currentState,
    state,
  })),
);
